import * as statuses from 'constants/statuses';

export default {
  status: {
    haircare: statuses.IDLE,
    skincare: statuses.IDLE,
  },
  data: {
    haircare: null,
    skincare: null,
  },
  error: null,
  subscriptionCreationStatus: statuses.IDLE,
  subscriptionModalStatus: statuses.IDLE,
};
